/* 🤖 this file was generated by svg-to-ts */
export const siriusListPlusDuotone: {
  name: 'list_plus_duotone';
  data: string;
} = {
  name: 'list_plus_duotone',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M3 6a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6ZM3 12a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12ZM3.75 17.25a.75.75 0 0 0 0 1.5h9.75a.75.75 0 0 0 0-1.5H3.75ZM16.5 18a.75.75 0 0 1 .75-.75h1.5v-1.5a.75.75 0 0 1 1.5 0v1.5h1.5a.75.75 0 0 1 0 1.5h-1.5v1.5a.75.75 0 0 1-1.5 0v-1.5h-1.5a.75.75 0 0 1-.75-.75Z" fill="currentColor"/></svg>`
};
